






































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import Hammer from 'hammerjs';
@Component({
  components: {},
})
export default class SwipeListItem extends Vue {
  private position = 0;
  private swipeActionWidth = 50;
  private isPanning = false;
  private panDeltaX = 0;
  private panThreshold = 40;

  public mounted() {
    const center = this.$refs.center as HTMLElement;
    const hammer = new Hammer(center);
    hammer.on('panstart', this.onPanStart);
    hammer.on('panmove', this.onPanMove);
    hammer.on('panend', this.onPanStop);
    hammer.on('pancancel', this.onPanStop);
  }

  public onPanStart(e: HammerInput) {
    this.isPanning = true;
  }

  public onPanMove(e: HammerInput) {
    this.panDeltaX = e.deltaX;
  }

  public onPanStop(e: HammerInput) {
    this.isPanning = false;

    if (Math.abs(e.deltaX) < this.panThreshold) {
      return;
    }

    const direction = e.offsetDirection;
    if (direction === Hammer.DIRECTION_LEFT) {
      this.position = Math.max(this.position - 1, -1);
    }

    if (direction === Hammer.DIRECTION_RIGHT) {
      this.position = Math.min(this.position + 1, 1);
    }
  }

  get pinnedStyle() {
    if (!this.isPanning) {
      return {
        transform: `translateX(${this.position * 33}%)`,
        transition: '0.5s',
      };
    }
  }

  get panningStyle() {
    if (this.isPanning) {
      return {
        transform: `translateX(${this.position * 33}%) translateX(${this.panDeltaX}px)`,
      };
    }
  }
}
